import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_users = (id) => {
  return instance.get(`/v1/mngr/users`, { headers });
};

export const post_user = (data) => {
  return instance.post(`/v1/mngr/user`, data, { headers });
};

export const put_user = (data) => {
  return instance.put(`/v1/mngr/user`, data, { headers });
};

export const delete_user = (id) => {
  return instance.delete(`/v1/mngr/user/${id}`, { headers });
};

export const auth_users = (data) => {
  return instance.post(`/auth`, data, { headers });
};
